<template>
	<inertia-head title="Announcements" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Announcements</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Announcements Management</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="text-end mb-4">
			<button @click="viewAnnouncementContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Content
			</button>
		</div>
		<div class="block block-rounded">
			<div class="block-header">
				<div class="block-title"></div>
				<div class="block-options">
					<div class="input-group">
						<div class="input-group-prepend"><span class="input-group-text">Membership Level</span></div>
						<select v-model="membership_level" class="form-select">
							<option value="ALL">ALL</option>
							<option value="TRC COUPLE">TRC COUPLE</option>
							<option value="SILVER">SILVER</option>
							<option value="GOLD">GOLD</option>
							<option value="DIAMOND">DIAMOND</option>
							<option value="PLATINUM">PLATINUM</option>
						</select>
					</div>
				</div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<!-- Pagination -->
					<pagination v-if="announcements.data.length > 0" :collections="announcements"/>
					<table class="table table-striped table-borderless table-hover table-vcenter">
						<thead>
							<tr>
								<th>PAGE LOCATION</th>
								<th>MEMBERSHIP LEVEL</th>
								<th>IMAGE</th>
								<th>TITLE</th>
								<th>START DATE</th>
								<th>END DATE</th>
								<th>STATUS</th>
								<th>CREATED</th>
								<th class="text-end">:::</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(announcement, a_index) in announcements.data"
								:key="announcement.announcement_id"
							>
								<td>{{announcement.page_location_format}}</td>
								<td>
									<span v-for="(level) in announcement.levels" class="badge me-2 mb-1"
										:class="{'bg-black':level=='TRC COUPLE','bg-danger':level=='TRC AI CIRCLE','bg-secondary':level=='SILVER','bg-primary':level=='GOLD','bg-warning':level=='DIAMOND','bg-success':level=='PLATINUM','bg-info':level=='ALL'}"
									>{{level}}</span>
								</td>
								<td>
									<img :src="announcement.announcement_img_url" style="width: 100%" />
								</td>
								<td>{{announcement.title}}</td>
								<td>{{announcement.start_datetime_format}}</td>
								<td>{{announcement.end_datetime_format}}</td>
								<td>
									<span v-if="announcement.is_active==0" class="text-danger">OFF</span>
									<span v-if="announcement.is_active==1" class="text-success">ON</span>
								</td>
								<td>{{announcement.created_at}}</td>
								<td class="text-end">
									<button @click="viewAnnouncementContentModal(a_index,'update')" type="button" class="btn btn-sm btn-alt-info"><i class="fa fa-pencil-alt"></i></button>
								</td>
							</tr>
							<tr v-if="announcements.data.length <= 0">
								<td colspan="9" class="mb-0 fw-semibold text-center p-5">NO ANNOUNCEMENT CONTENT FOUND.</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination v-if="announcements.data.length > 0" :collections="announcements"/>
			</div>
		</div>
		<add-update-announcement-content-modal ref="addUpdateAnnouncementContentModal" />
	</div>
</template>

<script>
import { onMounted, watch, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import AddUpdateAnnouncementContentModal from '../../Components/Admin/AddUpdateAnnouncementContentModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia';

export default {
	layout: AuthLayout,
	props: {
		announcements		: Object,
		membership_level 	: String,
		api_response 		: Object
	},
	components:{AddUpdateAnnouncementContentModal},
	setup(props) {
		
		const membership_level = ref(props.membership_level);

		const action = ref('add');

		const toast = createToaster();

		const selectedAnnouncementContent = reactive({});

		const addUpdateAnnouncementContentModal = ref(null);

		const viewAnnouncementContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedAnnouncementContent.announcement_id 		= props.announcements.data[_index].announcement_id;
				selectedAnnouncementContent.page_location 			= props.announcements.data[_index].page_location;
				selectedAnnouncementContent.membership_level 		= props.announcements.data[_index].membership_level;
				selectedAnnouncementContent.title 					= props.announcements.data[_index].title;
				selectedAnnouncementContent.description 			= props.announcements.data[_index].description;
				selectedAnnouncementContent.prev_announcement_img 	= props.announcements.data[_index].prev_announcement_img;
				selectedAnnouncementContent.announcement_img 		= props.announcements.data[_index].announcement_img;
				selectedAnnouncementContent.announcement_img_url 	= props.announcements.data[_index].announcement_img_url;
				selectedAnnouncementContent.start_datetime 			= props.announcements.data[_index].start_datetime;
				selectedAnnouncementContent.end_datetime 			= props.announcements.data[_index].end_datetime;
				selectedAnnouncementContent.is_active 				= props.announcements.data[_index].is_active;
			}

			addUpdateAnnouncementContentModal.value.setAnnouncementContent(_action,selectedAnnouncementContent);

			addUpdateAnnouncementContentModal.value.toggleModal();

		}

		watch(membership_level, (value,old_value) => {
			
			if(value!=old_value)
			{
				var param = {membership_level:value}

				if(value=="null")
				{
					param = "";
				}

				Inertia.get(
						'/admin/announcements', param,
						{
							// replace: true,
							preserveState: true,
							preserveScroll: true,
							only: ['announcements', 'membership_level']
						}
					)
			}
		})

		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action=='add' ? 'added' : 'updated';

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "danger"});
				}
			}
		})

		return{
			toast,
			action,
			membership_level,
			selectedAnnouncementContent,
			viewAnnouncementContentModal,
			addUpdateAnnouncementContentModal
		}
	},
}
</script>
